offSeasonHandler = {
    $galleryCarousel : $('.content-gallery-carousel'),

    init : function() {
        var self = this;

        if (self.$galleryCarousel.length > 0 && self.$galleryCarousel.find('.gallery-cell').length > 1) {
            
            self.$galleryCarousel.each(function(){
                let pageDots = $(this).hasClass('intro-gallery') ? true : false;

                var carouselOption = {
                    cellSelector: '.gallery-cell',
                    cellAlign: 'left',
                    pageDots: pageDots,
                    fade: false,
                    wrapAround: true,
                    prevNextButtons: true,
                    draggable: false,
                };
    
                if (Foundation.MediaQuery.only('small')) {
                    carouselOption = {
                        cellSelector: '.gallery-cell',
                        cellAlign: 'left',
                        pageDots: pageDots,
                        fade: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        draggable: true,
                    };
                }

                $(this).flickity(carouselOption);
            })
        }
    }
}